import React from 'react'

const Tags = ({ items }) => {
    return (
        <div className="filter-menu filter-button-group">
            {items.map((item, i) => (
                <div key={`tag-item-${i}`} className={`f_btn ${item.name === 'Application' && 'active'}`}>
                    <label><input type="radio" name="fl_radio" value={item.value} />{item.name}</label>
                </div>
            ))}
        </div>
    )
}

export default Tags